// @flow
/**
 * Whether to use window.history.
 * This is a function so that it can be hooked by unit tests.
 * @return {boolean}
 */
export default function canUseHistory() {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!(window.history && window.history.pushState && window.history.replaceState);
}
